import Container from "../../lib/Container/Container";
import "./ManagmentHome.scss";


function ManagementHome() {
  return (
    <div>
      <Container>
        <div className={"row row-cols-1 row-cols-lg-2  g-4 "}>
          خوش آمدید
        </div>
      </Container>
    </div>
  );
}



export default ManagementHome;
